import { useContext } from "react"
import { NavigationContext, NavigationInterface } from "./Navigation"

/**
 * @returns NavigationInterface {@link NavigationInterface}
 * @beta
 */
export function useNavigation(): NavigationInterface {
    return useContext(NavigationContext)
}
